function initializeSlider() {
  const container = getContainer();
  if (!container) {
    return;
  }
  const carousel = container.querySelector('.carousel-inner');
  const carouselControl = container.querySelector('.carousel__control');
  const items = container.querySelectorAll('.carousel-item');
  const pButton = container.querySelector('.carousel-previous-button');
  const nButton = container.querySelector('.carousel-next-button');
  let currentSlideNumber = document.querySelector('#current-slider-number');
  let currentIndex = 0;

  function applyTransition(item, transitionStyles) {
    item.style.transition = transitionStyles;
  }

  function getContainer() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 1023) {
      return document.querySelector('.free-samples-mobile');
    }
    return document.querySelector('.free-samples-desktop');
  }

  function getItemsToShow() {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1512) {
      return 4;
    } else if (screenWidth >= 1024) {
      return 3;
    } else {
      return 1;
    }
  }

  function updateCarousel() {
    const itemsToShow = getItemsToShow();
    const itemWidth = 100 / itemsToShow;
    const offset = currentIndex * itemWidth;

    carousel.style.transform = `translateX(-${offset}%)`;
  }

  currentSlideNumber.innerText = getItemsToShow();

  function fadeItemsOut(direction) {
    return new Promise((resolve) => {
    items.forEach((item) => {
    applyTransition(item, 'opacity 0.3s ease, transform 0.6s ease');
    item.style.opacity = 0;
    carousel.classList.replace('md:overflow-x-hidden', 'md:overflow-x-visible');
    
        if (direction === 'next') {
          toggleTranslateClasses(item, 'md:translate-x-6', 'md:-translate-x-6');
        } else if (direction === 'prev') {
          toggleTranslateClasses(item, 'md:-translate-x-6', 'md:translate-x-6');
        }
      });
    
      carousel.style.visibility = 'hidden';
      setTimeout(resolve, 600);
    });
  }

  function fadeItemsIn(direction) {
    carousel.classList.remove('md:-translate-x-6');
    
    items.forEach((item) => {
      applyTransition(item, 'opacity 0.6s ease 0.3s, transform 0.6s ease');
      item.style.opacity = 1;
      carousel.style.visibility = 'visible';
    
      if (direction === 'next') {
        setTimeout(() => {
          item.classList.remove('md:-translate-x-6');
        }, 300);
      } else if (direction === 'prev') {
        setTimeout(() => {
          item.classList.remove('md:translate-x-6', 'md:-translate-x-6');
        }, 300);
      }
    });
  }

  function toggleTranslateClasses(item, addClass, removeClass) {
    item.classList.remove(removeClass);
    item.classList.add(addClass);
    
    // Automatically revert after 300ms
    setTimeout(() => {
      item.classList.remove(addClass);
      item.classList.add(removeClass);
    }, 300);
  }

  async function slide(direction) {
    await fadeItemsOut(direction);
    const itemsToShow = getItemsToShow();
    const maxIndex = Math.max(0, items.length - itemsToShow);

    if (direction === 'next') {
      currentIndex = Math.min(currentIndex + itemsToShow, maxIndex);
      currentSlideNumber.innerText = Math.min(currentIndex + itemsToShow, items.length);
      pButton.classList.add("hover:scale-x-125");
      pButton.disabled = false;
      if (currentIndex + itemsToShow >= items.length) {
        nButton.classList.remove("hover:scale-x-125");
        nButton.disabled = true;
      }
    } else if (direction === 'prev') {
      if (currentIndex > 0) {
        currentIndex = Math.max(currentIndex - itemsToShow, 0);
      }
      currentSlideNumber.innerText = Math.min(currentIndex + itemsToShow, items.length);
  
      nButton.classList.add("hover:scale-x-125");
      nButton.disabled = false;
  
      if (currentIndex === 0) {
        pButton.classList.remove("hover:scale-x-125");
        pButton.disabled = true;
      }
    }
    
    updateCarousel();
    fadeItemsIn(direction);
  }

  function updateButtonVisibility() {
    const itemsToShow = getItemsToShow();
    if (carouselControl) {
      if (items.length <= itemsToShow) {
        carouselControl.style.display = 'none';
      } else {
        carouselControl.style.display = 'flex';
      }
    }
  }

  pButton.addEventListener('click', () => slide('prev'));
  nButton.addEventListener('click', () => slide('next'));

  window.addEventListener('resize', () => {
    updateCarousel();
    updateButtonVisibility();
  });

  updateCarousel();
  updateButtonVisibility();
}

// Initialize cart for the first time
document.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeSlider();
  },
  { once: true }
);

// Listen for custom event to reinitialize cart
document.addEventListener('cartUpdated', () => {
  initializeSlider();
});
